import styled from "styled-components";

export const IconStyled = styled.i`
  width: 30px;
`;
